export const BaseUrl = "https://colectio.com"; // Do not use window.xyz because of future SSR

export const NoValuePlaceholder = "–";

export const CatalogueItemsCountPerPage = 48;

export const UserSettings = {
  nameMaxLength: 60,
  nicknameMinLength: 2,
  nicknameMaxLength: 30,
  bioMaxLength: 500,
  passwordMinLength: 8,
};

export const Company = {
  name: "Colectio s.r.o.",
  taxId: "29309069",
  courtCity: "Brně",
  courtItemNo: "C 73039",
  street: "Dobrovského",
  building: "675/4",
  district: "Královo Pole",
  city: "Brno",
  zip: "612 00",
  map: "https://maps.app.goo.gl/FCeQsyFXPr7xiHVh7",
  email: "info@colectio.com",
  phone: "+420 777 361 698",
  dataBoxAddress: "yf696tg",
};

export const Socials = {
  instagram: "https://www.instagram.com/colectio.cz/",
  facebook: "https://www.facebook.com/Colectio.cz",
  linkedin: "https://www.linkedin.com/company/colectio-app/",
};

export const Website = {
  name: "Colectio",
};

export const Magazine = {
  articlesPerPage: 12,
};

export const PublicCollectionItems = {
  listing: {
    perPage: 30,
    filterDebounceTime: 300,
  },
};

export const Collectors = {
  perPage: 48,
  filterDebounceTime: 300,
};

export const ProfileSettings = {
  itemsPerPage: 30,
};

export const Chat = {
  maxMessageLength: 12000, // ~65k bytes, decided by DEV team 25.6.2024
};
